var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiskusNewheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.315,
    height: 55.25,
    viewBox: "0 0 177.315 55.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(-0.514 -0.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242",
    transform: "translate(67.808 15.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M13.546,28.31V3.969a.49.49,0,0,1,.491-.491h8.711a13.749,13.749,0,0,1,5.437,1A10.943,10.943,0,0,1,34.443,11.2a15.111,15.111,0,0,1,.785,4.9,14.929,14.929,0,0,1-.873,5.226,11.234,11.234,0,0,1-2.515,3.991,11.385,11.385,0,0,1-3.94,2.571,13.963,13.963,0,0,1-5.153.909H14.037A.49.49,0,0,1,13.546,28.31ZM30.271,16.1a10.683,10.683,0,0,0-.5-3.351,7.494,7.494,0,0,0-1.461-2.639A6.516,6.516,0,0,0,25.939,8.4a8.029,8.029,0,0,0-3.191-.6H18.963a.5.5,0,0,0-.5.5v15.7a.5.5,0,0,0,.5.5h3.785a7.711,7.711,0,0,0,3.227-.64,6.641,6.641,0,0,0,2.349-1.766,7.824,7.824,0,0,0,1.446-2.659A10.545,10.545,0,0,0,30.271,16.1Z",
    transform: "translate(-13.546 -3.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 4.779,
    height: 4.743,
    rx: 0.459,
    transform: "translate(25.068 0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 4.779,
    height: 18.686,
    rx: 0.095,
    transform: "translate(25.068 6.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M28.225,24.025a14.554,14.554,0,0,1-4.6-.749A11.407,11.407,0,0,1,20.1,21.407a.492.492,0,0,1-.114-.635l1.3-2.184a.493.493,0,0,1,.7-.155,14.868,14.868,0,0,0,2.9,1.544,9.018,9.018,0,0,0,3.227.625,4.09,4.09,0,0,0,2.251-.537,1.728,1.728,0,0,0,.816-1.534,1.531,1.531,0,0,0-.96-1.461A20.5,20.5,0,0,0,27.084,16q-1.82-.5-3.1-.966a7.839,7.839,0,0,1-2.065-1.048,3.572,3.572,0,0,1-1.141-1.358,4.315,4.315,0,0,1-.356-1.833,5.783,5.783,0,0,1,.553-2.571A5.589,5.589,0,0,1,22.52,6.283a7.117,7.117,0,0,1,2.339-1.229,9.342,9.342,0,0,1,2.9-.429,12.575,12.575,0,0,1,3.945.6A9.626,9.626,0,0,1,34.737,6.9a.494.494,0,0,1,.093.651l-1.4,2.107a.48.48,0,0,1-.682.124,10.729,10.729,0,0,0-2.36-1.27,7.5,7.5,0,0,0-2.659-.5,3.815,3.815,0,0,0-2.029.5,1.731,1.731,0,0,0-.821,1.6,1.558,1.558,0,0,0,.2.821,1.7,1.7,0,0,0,.625.573,6.255,6.255,0,0,0,1.121.48c.465.155,1.043.315,1.73.48,1.286.336,2.386.666,3.3,1a8.918,8.918,0,0,1,2.246,1.141,4.026,4.026,0,0,1,1.286,1.477,4.534,4.534,0,0,1,.408,2.014,5.193,5.193,0,0,1-2.029,4.332A8.77,8.77,0,0,1,28.225,24.025Z",
    transform: "translate(12.995 1.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M36.214,28.583,31.272,21.2a.5.5,0,0,0-.759-.077l-1.962,1.942a.587.587,0,0,0-.181.418V28.31a.489.489,0,0,1-.485.491h-3.8a.494.494,0,0,1-.491-.491V3.969a.494.494,0,0,1,.491-.491h3.8a.489.489,0,0,1,.485.491v13.3a.493.493,0,0,0,.862.325l6.48-7.281a.479.479,0,0,1,.367-.165h3.8a.488.488,0,0,1,.367.811l-5.985,6.816a.49.49,0,0,0-.036.6l6.7,9.651a.492.492,0,0,1-.4.769h-3.9A.5.5,0,0,1,36.214,28.583Z",
    transform: "translate(28.29 -3.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M40.085,24.025a14.553,14.553,0,0,1-4.6-.749,11.406,11.406,0,0,1-3.522-1.869.492.492,0,0,1-.114-.635l1.3-2.184a.488.488,0,0,1,.692-.155,14.9,14.9,0,0,0,2.907,1.544,9.018,9.018,0,0,0,3.227.625,4.083,4.083,0,0,0,2.246-.537,1.722,1.722,0,0,0,.821-1.534,1.531,1.531,0,0,0-.96-1.461A20.709,20.709,0,0,0,38.944,16q-1.82-.5-3.1-.966a7.758,7.758,0,0,1-2.065-1.048,3.573,3.573,0,0,1-1.141-1.358,4.315,4.315,0,0,1-.356-1.833,5.784,5.784,0,0,1,.552-2.571A5.589,5.589,0,0,1,34.38,6.283a7.143,7.143,0,0,1,2.334-1.229,9.4,9.4,0,0,1,2.907-.429,12.52,12.52,0,0,1,3.94.6A9.514,9.514,0,0,1,46.592,6.9a.489.489,0,0,1,.1.651l-1.4,2.107a.48.48,0,0,1-.682.124,10.729,10.729,0,0,0-2.36-1.27,7.5,7.5,0,0,0-2.659-.5,3.815,3.815,0,0,0-2.029.5,1.731,1.731,0,0,0-.821,1.6,1.558,1.558,0,0,0,.2.821,1.657,1.657,0,0,0,.625.573,6.1,6.1,0,0,0,1.121.48c.465.155,1.043.315,1.73.48,1.286.336,2.386.666,3.3,1a8.918,8.918,0,0,1,2.246,1.141,4.026,4.026,0,0,1,1.286,1.477,4.533,4.533,0,0,1,.408,2.014,5.193,5.193,0,0,1-2.029,4.332A8.77,8.77,0,0,1,40.085,24.025Z",
    transform: "translate(62.376 1.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M33.505,23.737a5.3,5.3,0,0,1-4.384-1.854,8.585,8.585,0,0,1-1.5-5.494V5.185a.486.486,0,0,1,.485-.491h3.8a.487.487,0,0,1,.491.491V15.357q0,4.314,3.1,4.317a4.909,4.909,0,0,0,2.69-.842,5.94,5.94,0,0,0,2.071-2.448.448.448,0,0,0,.052-.217V5.185a.49.49,0,0,1,.491-.491h3.8a.49.49,0,0,1,.491.491v12.7a1.688,1.688,0,0,0,.263,1.069.973.973,0,0,0,.511.3.484.484,0,0,1,.367.46v3.253a.488.488,0,0,1-.408.48,7.959,7.959,0,0,1-.79.1c-.32.026-.609.036-.873.036A3.442,3.442,0,0,1,42.082,23a2.314,2.314,0,0,1-.945-1.621l-.015-.2a.485.485,0,0,0-.847-.289,7.841,7.841,0,0,1-2.453,1.88A9.614,9.614,0,0,1,33.505,23.737Z",
    transform: "translate(45.069 1.585)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(0.514 0.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M42.214,20.448A18.016,18.016,0,0,1,24.761,38.459H1.984v-.005c.072-.083.145-.176.212-.269a3.913,3.913,0,0,0,.356-.583l.077-.17a4.191,4.191,0,0,0,.356-1.688A4.172,4.172,0,0,0,2.2,33.3c-.067-.093-.139-.186-.212-.274h22.24a12.573,12.573,0,0,0,0-25.147H7.881a2.716,2.716,0,1,1,0-5.432H24.792A18.013,18.013,0,0,1,42.214,20.448Z",
    transform: "translate(5.609 7.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 2.718,
    cy: 2.718,
    r: 2.718,
    transform: "translate(0 40.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 2.718,
    cy: 2.718,
    r: 2.718,
    transform: "translate(20.211 49.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M43.456,28.205a27.545,27.545,0,0,1-2.664,11.861c-.067.139-.139.284-.207.423a2.747,2.747,0,0,1-5.1-1.41,2.7,2.7,0,0,1,.191-1c.062-.124.124-.253.186-.377a22.207,22.207,0,0,0-6.589-27.124l-.506-.377A22.07,22.07,0,0,0,15.8,6.017H6.774A2.759,2.759,0,0,1,4,3.379,2.723,2.723,0,0,1,6.717.58h9.119a27.628,27.628,0,0,1,27.62,27.625Z",
    transform: "translate(13.981 -0.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M27.388,11.731a2.737,2.737,0,0,1-.8,1.931h-.005l-.232.212c-.583.516-1.188,1-1.812,1.466a27.5,27.5,0,0,1-16.1,5.437H5.856l.067-.083a4.17,4.17,0,0,0-.067-5.355H8.335A22.111,22.111,0,0,0,22.762,9.763l.155-.139.005-.005a2.733,2.733,0,0,1,4.467,2.112Z",
    transform: "translate(21.73 34.473)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskusNewheader);
export default __webpack_public_path__ + "static/media/diskus_newheader.8d1025f34f029f9b99290d4aa1c70642.svg";
export { ForwardRef as ReactComponent };